export var WidgetTemplateName;
(function (WidgetTemplateName) {
    WidgetTemplateName["Basic"] = "basic";
    WidgetTemplateName["VisualPerformance"] = "visual-performance";
    WidgetTemplateName["Performance"] = "performance";
    WidgetTemplateName["Visual"] = "visual";
    WidgetTemplateName["Report"] = "report";
    WidgetTemplateName["RapNet"] = "rapnet";
    WidgetTemplateName["Video"] = "video";
})(WidgetTemplateName || (WidgetTemplateName = {}));
